<template>
  <div class="charts-container">
    <div class="charts-grid">
      <ChartCard 
        v-for="item in renderedItems"
        :key="item.key"
        :task-id="taskId"
        :group-name="groupName"
        :filename="item.filename"
        :chart-payload="item.chartPayload"
        :chart-title="item.chartTitle"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import ChartCard from './ChartCard.vue';

const props = defineProps({
  taskId: {
    type: Number,
    default: null,
  },
  groupName: {
    type: String,
    default: null,
  },
  chartFileNames: {
    type: Array,
    default: () => [],
  },
  chartItems: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['open-charts', 'switch-tab']);

const handleOpenCharts = (data) => {
  console.log('Opening charts:', data);
  emit('open-charts', data);
};

const renderedItems = computed(() => {
  if (Array.isArray(props.chartItems) && props.chartItems.length > 0) {
    return props.chartItems.map((item, index) => ({
      key: `payload-${index}-${item?.title || item?.name || ''}`,
      filename: null,
      chartPayload: item?.payload || item,
      chartTitle: item?.title || item?.name || '',
    }));
  }

  return (props.chartFileNames || []).map((file, index) => ({
    key: `file-${index}-${file}`,
    filename: file,
    chartPayload: null,
    chartTitle: '',
  }));
});
</script>

<style lang="scss" scoped>
.charts-container {
  padding: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.charts-grid {
  flex: 1;
  min-height: 0;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
  align-content: flex-start;
}

// Style for ChartCard components in the grid
::v-deep(.chart-card) {
  flex: 0 0 auto;
  width: 100%;
  min-width: 0;
  height: auto;
  min-height: 350px;
}

.chart-placeholder {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 40px 20px;
  text-align: center;
  background: #f9f9f9;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
  min-width: 0;

  &:hover {
    border-color: #999;
    background: #f0f0f0;
  }

  .placeholder-icon {
    font-size: 32px;
    margin-bottom: 12px;
  }

  p {
    margin: 0;
    color: #666;
    font-size: 14px;
  }
}
</style>
